// extracted by mini-css-extract-plugin
export var component = "layout-module--component--95C1n";
export var componentWidthFull = "layout-module--component-width-full--ALhLK";
export var componentWidthNarrow = "layout-module--component-width-narrow--eah8w";